import { useState, useEffect } from 'react';
import config from '../config';
import { formatearRut, capitalizeFirstLetter } from '../helpers/formatters';

export function EstadoPagoGTModalContent({ dataLogin, data, obtenerEstadosPagoGT, estadosPagoEstado, setSecondModalOpen, setSecondModalContent, closeSecondModal, onClose, navigate, handleVerPDFep, handleEnviaEP }) {
  const [cardData, setCardData] = useState(data);
  const [tiposDocumentos, setTiposDocumentos] = useState([]);
  const [estadoPagoEstado, setEstadoPagoEstado] = useState(data.id_estado_pago_estado);
  const [estadoPagoReportsGT, setEstadoPagoReportsGT] = useState([]);
  const [estadoPagoServiciosGT, setEstadoPagoServiciosGT] = useState([]);
  const [estadoPagoDocumentosGT, setEstadoPagoDocumentosGT] = useState([]);
  const [detalleCotizacion, setDetalleCotizacion] = useState([]);
  const [submitFacturarDisabled, setSubmitFacturarDisabled] = useState(true);
  const idExtrasGrua = [88, 207, 225];
  
  //Para inputs de fechas
  const today = new Date();

  useEffect(() => {
    obtenerTiposDocumentos();
    obtenerReportsGT(data.id_estado_pago_gt);
    obtenerServiciosGT(data.id_estado_pago_gt);
    obtenerDocumentosGT(data.id_estado_pago_gt);
    obtenerDetalleCotizacion(data.folio);

    if (data.id_estado_pago_estado === 4) {
      setSubmitFacturarDisabled(false);
    }
  }, []);

  const obtenerTiposDocumentos = async () => {
    try {
      const response = await fetch(
        `${config.apiBaseUrl}/tipo_documento.php`
      );
      const data = await response.json();

      if (data && data[0].id_tipo_documento) {
        setTiposDocumentos(data);
      }
    } catch (error) {
      setTiposDocumentos([]);
    }
  };

  const obtenerDocumentosGT = async (id_estado_pago_gt) => {
    try {
      const response = await fetch(
        `${config.apiBaseUrl}/estado_pago_documentos_gt.php?id_estado_pago_gt=${id_estado_pago_gt}`
      );
      const data = await response.json();

      if (data && data[0].id_estado_pago_documentos_gt) {
        setEstadoPagoDocumentosGT(data);
      }
    } catch (error) {
      setEstadoPagoDocumentosGT([]);
    }
  };

  const obtenerDetalleCotizacion = async (folio) => {
    try {
      const response = await fetch(
        `${config.apiBaseUrl}/detalle_cotizacion.php?folio=${folio}`
      );
      const data = await response.json();

      if (data && data[0].id_servicio) {
        setDetalleCotizacion(data);
      }
    } catch (error) {
      setDetalleCotizacion([]);
    }
  };

  const obtenerReportsGT = async (id_estado_pago_gt) => {
    try {
      const response = await fetch(
        `${config.apiBaseUrl}/estado_pago_reports_gt.php?id_estado_pago_gt=${id_estado_pago_gt}`
      );
      const data = await response.json();

      if (data && data[0].id_estado_pago_gt) {
        setEstadoPagoReportsGT(data);
      }
    } catch (error) {
      setEstadoPagoReportsGT([]);
    }
  };

  const obtenerServiciosGT = async (id_estado_pago_gt) => {
    try {
      const response = await fetch(
        `${config.apiBaseUrl}/estado_pago_servicios_gt.php?id_estado_pago_gt=${id_estado_pago_gt}`
      );
      const servicios = await response.json();

      if (servicios && servicios[0].id_estado_pago_gt) {
        setEstadoPagoServiciosGT(servicios);
      }
    } catch (error) {
      setEstadoPagoServiciosGT([]);
    }
  };

  useEffect(() => {
    const tieneDetalle = Array.isArray(detalleCotizacion) && detalleCotizacion.length > 0;
    const tieneReportes = Array.isArray(estadoPagoReportsGT) && estadoPagoReportsGT.length > 0;
    const tieneServicios = Array.isArray(estadoPagoServiciosGT) && estadoPagoServiciosGT.length > 0;

    if (tieneDetalle && (tieneReportes || tieneServicios)) {
      obtenerResumenFacturar();
      // 1. Buscar el primer servicio que esté en idExtrasGrua
      const servicioExtra = estadoPagoServiciosGT.find(s => idExtrasGrua.includes(s.id_servicio));

      if (servicioExtra) {
        const valorUnitario = Number(servicioExtra.valor_unitario_neto); // número, no string

        setCardData(prev => {
          const total =
            Number(prev.valor_uf_fecha_facturacion) *
            valorUnitario *
            Number(prev.horas_adicionales_grua);

          return {
            ...prev,
            valor_hora_adicional_uf_grua: Number(valorUnitario.toFixed(4)), // guarda como número con 4 decimales
            valor_total_horas_adicionales_grua: Math.round(total) // 0 decimales (ej: 41373)
          };
        });
      }

    }
  }, [estadoPagoReportsGT, estadoPagoServiciosGT, detalleCotizacion]);

  const [jsonPIGT, setJsonPIGT] = useState([]);
  const [detalleEquipos, setDetalleEquipos] = useState([]);

  const obtenerResumenFacturar = () => {
    //JSON para PIG-T
    const objetoPIGT = (dataCotizacion, detalleCotizacion) => {
      let rutClienteFormateado = formatearRut(dataCotizacion?.rut_cliente || '');

      //Afecto
      const afecto = estadoPagoServiciosGT.reduce((acc, servicio) => {
        return acc + parseFloat(servicio.valor_total);
      }, 0);

      //Recargo
      //const recargo = Number(data.valor_total_horas_adicionales_operador) + Number(data.valor_total_horas_adicionales_grua);
      const recargo = Number(data.valor_total_horas_adicionales_operador) + Number(data.valor_total_horas_adicionales_grua);

      const detalleDocumentos = estadoPagoDocumentosGT.map(doc => {
        let tipoDocumento = doc.tipo_documento;
        let fechaDocumentoFormateada = `${doc.fecha_detalle.split('-')[2]}-${doc.fecha_detalle.split('-')[1]}-${doc.fecha_detalle.split('-')[0]}T00:00:00`;

        // Modifica el tipo de documento según corresponda
        if (doc.tipo_documento === "HES") {
          tipoDocumento = "HES (Hoja Entrada De Servicio)";
        } else if (doc.tipo_documento === "Orden de Trabajo") {
          tipoDocumento = "OT (Orden de Trabajo)";
        }
        return {
          TpoDocRef: tipoDocumento,
          FolioRef: doc.detalle,
          FechaRef: fechaDocumentoFormateada,
          RazonRef: data.folio
        };
      });
      
      const detalleRedondeado = detalleCotizacion.map(item => ({
        ...item,
        PrecioUnitario: Math.round(item.PrecioUnitario),
        Total: Math.round(item.Total),
        Descuento: Math.round(item.Descuento),
        PorcDescuento: Math.round(item.PorcDescuento)
      }));

      const nuevoObjeto = [
        {
          'Folio': 0,
          'Usuario': "pamela.varas@vittamaq.cl", // Usuario de Kame
          'Documento': "Factura Electrónica",
          'Rut': rutClienteFormateado,
          'TipoDocumento': "PEDIDO", // en pruebas es PEDIDO para produccion debe ser VENTA
          'RznSocial': dataCotizacion.razon_social.toUpperCase(),
          'Giro': dataCotizacion.giro.toUpperCase(),
          'Direccion': dataCotizacion.direccion.toUpperCase(),
          'Ciudad': dataCotizacion.ciudad.toUpperCase(),
          'Comuna': dataCotizacion.comuna.toUpperCase(),
          'Telefono': dataCotizacion.telefono_representante,
          'Email': dataCotizacion.email_solicitante,
          'Fecha': "",
          'Comentario': "FOLIO COTIZACION: " + dataCotizacion.folio,
          'FormaPago': "1",
          'Afecto': Number(afecto).toFixed(0),// CN agrega el recargo
          'Exento': 0,
          'Descuento': Number(data.otros_descuentos).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, ''),
          'TipoImpto1': "IVA",
          'ValorImpto1': Number(data.iva).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, ''),
          'total': Number(data.total).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, ''),
          'FechaVencimiento': "",
          'Bodega': "",//data.bodega.toUpperCase(),
          'EsInventariable': "",
          'Vendedor': data.vendedor.toUpperCase(),
          'Recargo': 0, //recargo,
          'PorcDescuento': 0,
          'PorcRecargo': 0,
          'Contacto': dataCotizacion.email_solicitante,
          'Observacion': "",
          'Comision': null,
          'FormaCredito': "",
          'FichaDireccion': "",
          'Detalle': detalleRedondeado,
          'Referencias': detalleDocumentos
        }
      ];

      return nuevoObjeto;
    };

    // Agrupar por numero de equipo
    const convertirHorasADecimales = (horas) => {
      const [hh, mm, ss] = horas.split(':').map(Number);
      return hh + (mm / 60) + (ss / 3600); // Convierte minutos y segundos a fracciones de hora
    };

    const tieneReportes = Array.isArray(estadoPagoReportsGT) && estadoPagoReportsGT.length > 0;
    const tieneServicios = Array.isArray(estadoPagoServiciosGT) && estadoPagoServiciosGT.length > 0;

    if (!tieneReportes && !tieneServicios) {
      alert("No hay reportes ni servicios disponibles para generar la factura.");
      return;
    }
    let numeroEquipo = data.numero_equipo || data.nombre_equipo;
    let nombreObra = data.nombre_obra?.toUpperCase() || "OBRA SIN NOMBRE";

    let descripcion = `ARRIENDO MENSUAL DE GRUA TORRE ${numeroEquipo}`;
    let descripcionDetallada = `ARRIENDO MENSUAL DE GRUA TORRE ${numeroEquipo} - OBRA: ${nombreObra}`;

    let totalHorasTrabajadas = "";
    let valorTotalReportes = 0;
    let fechaReport = null;

    if (tieneReportes) {
      const agrupado = estadoPagoReportsGT.reduce((acc, current) => {
        if (!acc.total_horas) acc.total_horas = 0;
        acc.total_horas += convertirHorasADecimales(current.total_horas);
        acc.valor_total = (acc.valor_total || 0) + Number(current.valor_total || 0);
        acc.fecha_report = current.fecha_report;
        return acc;
      }, {});

      totalHorasTrabajadas = agrupado.total_horas.toFixed(2);
      valorTotalReportes = agrupado.valor_total;
      fechaReport = new Date(agrupado.fecha_report.split('-').reverse().join('-'));

      descripcionDetallada += `, ${totalHorasTrabajadas} TOTAL HORAS, ${valorTotalReportes.toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.')} TOTAL VALOR HORAS TRABAJADAS - SEGUN REPORT ${fechaReport.toLocaleString('es-CL', { month: 'long' }).toUpperCase()} ${fechaReport.getFullYear()}`;
    }

    const valorTotalServicios = tieneServicios ? estadoPagoServiciosGT.reduce((acc, s) => acc + Number(s.valor_total || 0), 0) : 0;

    if (tieneServicios) {
      const serviciosTexto = estadoPagoServiciosGT.map(servicio => {
        const nombre = servicio.glosa_servicio || "SERVICIO";
        const valor = Number(servicio.tipo_facturacion === 'completa' ? servicio.valor_unitario_neto : servicio.valor_parcial_neto || 0).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.');
        return `+ ${nombre.toUpperCase()} ${valor} UF`;
      }).join(' ');
      descripcionDetallada += ` ${serviciosTexto}`;
    }

    const valorTotalFinal = valorTotalReportes + valorTotalServicios;

    const datosDescripcion = [{
      Descripcion: descripcion,
      Cantidad: 1,
      PrecioUnitario: valorTotalFinal,
      Total: valorTotalFinal,
      Descuento: 0,
      UnidadMedida: "UN",
      UnidadNegocio: "CASA MATRIZ",
      Articulo: "ARRIENDO GRUA TORRE",
      PorcDescuento: 0,
      DescripcionDetallada: descripcionDetallada,
      Exento: "",
      TipoExento: "",
      CuentaEmpresaVenta: "",
      TipoArticulo: ""
    }];

    setJsonPIGT(objetoPIGT(data, datosDescripcion));
  };

  const handleDateFacturacionChange = (event) => {
    const selectedDate = event.target.value; // Obtiene la nueva fecha seleccionada (formato YYYY-MM-DD)

    // Convertir la fecha seleccionada a formato ISO 8601 (sin fracciones de segundo)
    const newDate = new Date(selectedDate).toISOString().split('.')[0];

    // Actualizar el estado del jsonPIGT
    setJsonPIGT((prevJsonPigT) => {
      if (!Array.isArray(prevJsonPigT)) return prevJsonPigT; // o [] si quieres inicializarlo

      return prevJsonPigT.map((item, index) =>
        index === 0
          ? { ...item, Fecha: newDate, FechaVencimiento: newDate }
          : item
      );
    });
  };

  const handleModificaEstado = (data_estado_pago, id_estado_pago_estado) => {
    if (id_estado_pago_estado === '3' && (!Array.isArray(jsonPIGT) || !jsonPIGT[0] || jsonPIGT[0].Fecha === "")) {
      alert('Debe indicar una fecha de facturación');
      return false;
    } else if (dataTotales.total === 0) {
      alert("No puede facturar el estado de pago con valores en 0");
      return false;
    } else {
      setEstadoPagoEstado(id_estado_pago_estado);
      setSecondModalOpen(true);
      setSecondModalContent(<ConfirmaModificaEstadoModalContent dataEstadoPago={data_estado_pago} idEstadoPagoEstado={id_estado_pago_estado} />);
    }
  };

  function ConfirmaModificaEstadoModalContent({ dataEstadoPago, idEstadoPagoEstado }) {
    const obtenerEstadoPorId = (idEstadoPagoEstado) => {
      const estadoEncontrado = estadosPagoEstado.find(estado => estado.id_estado_pago_estado === idEstadoPagoEstado);
      return estadoEncontrado ? estadoEncontrado.estado_pago_estado : 'Estado no encontrado';
    };

    const estado = obtenerEstadoPorId(Number(idEstadoPagoEstado));

    return (
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="mb-0">Modificar Estado: {dataEstadoPago.folio}</h4>
            <button onClick={closeSecondModal} className="btn-close"></button>
          </div>
          <div className="modal-body">
            <p className="fs-5">¿Está seguro que desea modificar el estado del estado de pago GT a: {idEstadoPagoEstado === '2' ? <span className="text-red">{estado}</span> : <span className="text-orange">{estado}</span>} ?</p>
          </div>
          <div className="modal-footer">
            <button className={idEstadoPagoEstado === '2' ? "btn btn-danger" : "btn btn-yellow"} onClick={(e) => handleSubmitModificarEstado(e, dataEstadoPago.id_estado_pago_gt, idEstadoPagoEstado)}>
              {idEstadoPagoEstado === '2' ? (
                <span>
                  <i className="bi bi-dash-circle"></i> Anular Estado de Pago
                </span>
              ) : (
                <span>
                  <i className="bi bi-check-circle"></i> Facturar Estado de Pago GT
                </span>
              )}
            </button>
          </div>
        </div>
      </div>
    );
  }

  const [dataTotales, setDataTotales] = useState({
    otros_descuentos: Number(data.otros_descuentos).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, ''),
    total_neto: Number(data.total_neto).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, ''),
    iva: Number(data.iva).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, ''),
    total: Number(data.total).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '')
  });

  const [checkboxStatesServ, setCheckboxStatesServ] = useState({});
  const [serviciosFacturar, setServiciosFacturar] = useState([]);

  // Inicializar checkboxStatesServ con todos los valores en true
  useEffect(() => {
    const initialCheckboxStates = {};
    estadoPagoServiciosGT.forEach((_, index) => {
      initialCheckboxStates[index] = true;
    });
    setCheckboxStatesServ(initialCheckboxStates);

    const idServiciosFacturar = estadoPagoServiciosGT.map(item => (
      {
        id_servicio: item.id_servicio,
        glosa_servicio:
          item.glosa_servicio !== null && item.glosa_servicio !== '' ? (
            item.glosa_servicio
          ) : (
            item.id_equipo === 0 ? (
              item.nombre_maquinaria + " - " + item.tipo_arriendo
            ) : (
              item.nombre_maquinaria + " - " + item.nombre_equipo + " - " + item.tipo_arriendo
            )
          )
      }
    ));

    setServiciosFacturar(idServiciosFacturar);
  }, [estadoPagoServiciosGT]);

  const toggleCheckbox = (index, idServicio, glosaServicio, valorServicio) => {
    setCheckboxStatesServ(prevState => {
      const isChecked = !prevState[index];

      const newState = {
        ...prevState,
        [index]: isChecked
      };

      // Actualizar el total_neto en función de si el checkbox está marcado o desmarcado
      setDataTotales(prevDataTotales => {
        const newOtrosDescuentos = Number(data.otros_descuentos).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '');
        const newTotalNeto = isChecked
          ? prevDataTotales.total_neto + Number(valorServicio)
          : prevDataTotales.total_neto - Number(valorServicio);

        //Cálculo de totales
        const newIva = Number(newTotalNeto * 0.19).toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/\./g, '').toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '');
        const newTotal = Number(Number(newTotalNeto * 1.19) /* - Number(newOtrosDescuentos) */).toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/\./g, '').toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '');

        if (newTotalNeto <= 0) {
          return {
            ...prevDataTotales,
            otros_descuentos: 0,
            total_neto: 0,
            iva: 0,
            total: 0
          };
        } else {
          return {
            ...prevDataTotales,
            otros_descuentos: newOtrosDescuentos,
            total_neto: newTotalNeto,
            iva: newIva,
            total: newTotal
          };
        }
      });

      // Actualiza valores de facturación si el checkbox está marcado o desmarcado
      setJsonPIGT(prevJsonPigT => {
        const newOtrosDescuentos = Number(prevJsonPigT[0].Descuento).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '');

        let newTotalNeto = 0;
        let newIva = 0;
        let newTotal = 0;

        if (isChecked) {
          newTotalNeto = Number(prevJsonPigT[0].Afecto) + Number(valorServicio);
          newIva = Number(Number(Number(newTotalNeto) + Number(prevJsonPigT[0].Recargo) - Number(newOtrosDescuentos)) * 0.19)
          newTotal = Number(Number(Number(newTotalNeto) + Number(prevJsonPigT[0].Recargo) - Number(newOtrosDescuentos)) * 1.19)
          setDetalleEquipos(prevDetalle =>
            prevDetalle.map(item => ({
              ...item,
              total_horas_trabajadas_valor: newTotalNeto // Nuevo valor
            }))
          );
        } else {
          newTotalNeto = Number(prevJsonPigT[0].Afecto) - Number(valorServicio);

          if (Number(newTotalNeto) < 0) {
            newTotalNeto = 0;
          }

          newIva = Number(Number(newTotalNeto) + Number(Number(prevJsonPigT[0].Recargo) - Number(newOtrosDescuentos)) * 0.19)
          newTotal = Number(Number(newTotalNeto) + Number(prevJsonPigT[0].Recargo) + Number(newIva) - Number(newOtrosDescuentos))

          setDetalleEquipos(prevDetalle =>
            prevDetalle.map(item => ({
              ...item,
              total_horas_trabajadas_valor: newTotal // Nuevo valor
            }))
          );
        }

        return prevJsonPigT.map((item, index) =>
          index === 0
            ? {
              ...item,
              Afecto: newTotalNeto,
              ValorImpto1: newIva,
              total: newTotal
            }
            : item
        );
      });

      //Servicios a facturar
      setServiciosFacturar(prevServicios => {
        if (isChecked) {
          if (!prevServicios.some(servicio => servicio.id_servicio === idServicio)) {
            return [...prevServicios, { id_servicio: idServicio, glosa_servicio: glosaServicio }];
          } else {
            return prevServicios;
          }
        } else {
          return prevServicios.filter(servicio => servicio.id_servicio !== idServicio);
        }
      });
      return newState;
    });
  };

  const handleSubmitModificarEstado = async (event, idEstadoPagoGT, idEstadoPagoEstado) => {
    event.preventDefault();

    try {
      closeSecondModal();
      onClose();

      if (idEstadoPagoEstado === "2") {
        const formModificarEstado = {
          id_estado_pago_gt: idEstadoPagoGT,
          total_neto: dataTotales.total_neto,
          iva: dataTotales.iva,
          total: dataTotales.total,
          id_estado_pago_estado: idEstadoPagoEstado,
          id_usuario_actualizacion: dataLogin.id_usuario
        };

        const responseModificarEstado = await fetch(
          `${config.apiBaseUrl}/estado_pago_gt.php`,
          {
            method: "PUT",
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formModificarEstado),
          }
        );

        const dataModificarEstado = await responseModificarEstado.json();
        if (dataModificarEstado.message === "Estado de pago modificado con éxito.") {
          const habilitaReportsData = {
            habilita_report: 1,
            reports: estadoPagoReportsGT.map(item => ({
              id_report_gt: item.id_report_gt
            }))
          };

          const responseReportsActualizados = await fetch(
            `${config.apiBaseUrl}/report_gt.php`,
            {
              method: "PUT",
              headers: {
                'Accept': 'application/json', // Indica que esperas una respuesta JSON
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(habilitaReportsData),
            }
          );

          const dataResponseReportsActualizados = await responseReportsActualizados.json();
          if (dataResponseReportsActualizados.message === "Report GT habilitado exitosamente.") {
            alert("Estado de pago anulado con éxito.");

            obtenerEstadosPagoGT();

            navigate("/dashboard", { state: dataLogin });
          }
        } else {
          throw new Error();
        }
      } else {
        if (jsonPIGT.length > 0) {
          console.info(JSON.stringify(jsonPIGT))
          //alert('Aqui integra')
          const responseKame = await fetch(
            `https://app.pig-t.cl/vittamaq_Cotizaciones_Kame`,
            {
              method: "POST",
              headers: {
                'Accept': 'application/json',
              },
              body: JSON.stringify(jsonPIGT),
            }
          );

          const dataResponseKame = await responseKame.json();
          console.log(JSON.stringify(dataResponseKame, null, 2));

          if (dataResponseKame.phrase === "OK" && dataResponseKame.kameresponse.Estado === "Ok") {
            const fechaFacturacionFormateada = jsonPIGT[0].Fecha.split('T')[0];
            const formFolioKame = { id_estado_pago_gt: data.id_estado_pago_gt, folio_kame: dataResponseKame.kameresponse.Folio, fecha_facturacion: fechaFacturacionFormateada, id_estado_pago_estado: idEstadoPagoEstado, id_usuario_actualizacion: dataLogin.id_usuario };
            const responseActualizaFolioKame = await fetch(
              `${config.apiBaseUrl}/estado_pago_gt.php`,
              {
                method: "PUT",
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(formFolioKame),
              }
            );

            const dataActualizaFolioKame = await responseActualizaFolioKame.json();
            if (dataActualizaFolioKame.message === "Folio de Kame agregado con éxito.") {
              const facturaReportsData = estadoPagoReportsGT.map(item => ({
                id_report_gt: item.id_report_gt,
              }));

              const responseReportsActualizados = await fetch(
                `${config.apiBaseUrl}/report_gt.php`,
                {
                  method: "PUT",
                  headers: {
                    'Accept': 'application/json', // Indica que esperas una respuesta JSON
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify(facturaReportsData),
                }
              );

              const dataResponseReportsActualizados = await responseReportsActualizados.json();
              if (dataResponseReportsActualizados.message === "Reports de estado de pago actualizados con éxito.") {
                alert("Estado de pago facturado con éxito.");

                obtenerEstadosPagoGT();

                navigate("/dashboard", { state: dataLogin });
              }
            }
          } else {
            alert("Error al facturar el estado de pago, verifique la información.")
            throw new Error();
          }
        }
      }
    } catch (error) {
      obtenerEstadosPagoGT();
    }
  }

  //DOCUMENTOS
  const [activeTab, setActiveTab] = useState('resumen');
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const filaPredeterminada = {
    id: 1,
    folio: data.folio,
    id_estado_pago_gt: data.id_estado_pago_gt,
    id_tipo_documento: '',
    detalle: '',
    fecha: '',
    id_usuario: dataLogin.id_usuario.toString()
  };
  const [filas, setFilas] = useState([filaPredeterminada]);

  const handleAgregarFila = () => {
    const nuevaFila = {
      id: filas.length + 1,
      folio: data.folio,
      id_estado_pago_gt: data.id_estado_pago_gt,
      id_tipo_documento: '',
      detalle: '',
      fecha: '',
      id_usuario: dataLogin.id_usuario.toString()
    };

    setFilas([...filas, nuevaFila]);
  };

  const handleInputChange = (id, campo, valor) => {
    const nuevasFilas = filas.map((fila) =>
      fila.id === id ? { ...fila, [campo]: valor } : fila
    );

    setFilas(nuevasFilas);
  };

  const handleEliminarFila = (id) => {
    if (filas.length > 1) {
      const nuevasFilas = filas.filter((fila) => fila.id !== id);
      setFilas(nuevasFilas);
    } else {
      alert("Debe agregar al menos un documento.");
    }
  };

  const handleConfirmaDocumentos = (e, filas) => {
    const esFormularioValido = validaFormularioDocumentos(filas);

    if (!esFormularioValido) {
      alert("Debe completar la información de los documentos.")
    } else {
      setSecondModalOpen(true);
      setSecondModalContent(<ConfirmaDocumentosModalContent documentos={filas} />);
    }
  };

  function ConfirmaDocumentosModalContent({ documentos }) {
    const tipoDocumentoMap = tiposDocumentos.reduce((acc, tipo) => {
      acc[tipo.id_tipo_documento] = tipo.tipo_documento;
      return acc;
    }, {});

    const documentosConTipo = documentos.map(doc => {
      return {
        ...doc,
        tipo_documento: tipoDocumentoMap[doc.id_tipo_documento]
      };
    });

    return (
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="mb-0">Confirmar Documentos</h4>
            <button onClick={closeSecondModal} className="btn-close"></button>
          </div>
          <div className="modal-body">
            <p className="fs-5">¿Está seguro que desea ingresar los siguientes documentos?:</p>
            <table className="table table-hover table-sm mb-0">
              <thead>
                <tr className="table-active">
                  <th className="ps-2">Tipo Documento</th>
                  <th>Número</th>
                  <th className="pe-2">Fecha</th>
                </tr>
              </thead>
              <tbody>
                {documentosConTipo.length > 0 ? (
                  documentosConTipo.map((documento, index) => (
                    <tr key={index}>
                      <td className="ps-2">{documento.tipo_documento}</td>
                      <td>{documento.detalle}</td>
                      <td className="pe-2">{documento.fecha.split('-').reverse().join('-')}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td className="text-center ps-1" colSpan={3}>No se encontraron documentos asociados</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="modal-footer">
            <button className="btn btn-yellow" onClick={handleSubmitDocumentos}><i className="bi bi-floppy"></i> Guardar</button>
          </div>
        </div>
      </div>
    );
  }

  const handleSubmitDocumentos = async (event) => {
    event.preventDefault();

    try {
      const response = await fetch(
        `${config.apiBaseUrl}/estado_pago_documentos_gt.php`,
        {
          method: "POST",
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(filas),
        }
      );

      const dataResponse = await response.json();
      if (dataResponse.message === "Documentos GT ingresados con éxito.") {
        alert("Documentos agregados al estado de pago con éxito.");

        obtenerEstadosPagoGT();

        closeSecondModal();
        onClose();

        navigate("/dashboard", { state: dataLogin });
      } else {
        throw new Error();
      }
    } catch (error) {
      obtenerEstadosPagoGT();
    }
  }

  const validaFormularioDocumentos = (datos_documentos) => {
    return datos_documentos.every(item => {
      return item.id && item.folio && item.id_estado_pago_gt &&
        item.id_tipo_documento && item.detalle &&
        item.fecha && item.id_usuario;
    });
  };

  return (
    <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
      <div className="modal-content">
        <div className="modal-header">
          <h4 className="mb-0">Detalle Estado Pago: Grúa Torre (GT-{data.id_estado_pago_gt}) ({data.estado_pago_estado})</h4>
          <button onClick={onClose} className="btn-close"></button>
        </div>
        <div className="modal-body">
          <div className="row row-cols-md-2 mb-4">
            <div className="col">
              <ul className="list-group">
                <li className="list-group-item d-flex justify-content-between align-items-center">
                  <span className="form-label mb-0">Folio</span>
                  <span className="label">{data.folio || ""}</span>
                </li>
                <li className="list-group-item d-flex justify-content-between align-items-center">
                  <span className="form-label mb-0">Fecha Estado Pago</span>
                  <span className="label">{data.fecha_estado_pago || ""}</span>
                </li>
                <li className="list-group-item d-flex justify-content-between align-items-center">
                  <span className="form-label mb-0">Equipo</span>
                  <span className="label">{data.nombre_equipo || ""}</span>
                </li>
                <li className="list-group-item d-flex justify-content-between align-items-center">
                  <span className="form-label mb-0">Lugar de Faena</span>
                  <span className="label">{data.nombre_obra || ""}</span>
                </li>
              </ul>
            </div>
            <div className="col">
              <ul className="list-group">
                <li className="list-group-item d-flex justify-content-between align-items-center">
                  <span className="form-label mb-0">Rut</span>
                  <span className="label">{`${formatearRut(data.rut_cliente)}` || ""}</span>
                </li>
                <li className="list-group-item d-flex justify-content-between align-items-center">
                  <span className="form-label mb-0">Cliente</span>
                  <span className="label">{data.nombre_cliente || ""}</span>
                </li>
                <li className="list-group-item d-flex justify-content-between align-items-center">
                  <span className="form-label mb-0">Cliente Final</span>
                  <span className="label">{data.nombre_cliente_final || ""}</span>
                </li>
                <li className="list-group-item d-flex justify-content-between align-items-center">
                  <span className="form-label mb-0">Email Solicitante</span>
                  <span className="label">{data.email_solicitante || ""}</span>
                </li>
              </ul>
            </div>
          </div>
          <h5 className="mb-3">Detalle Reports</h5>
          <div className="table-responsive border rounded mb-4">
            <table className="table text-center table-sm mb-0">
              <thead>
                <tr className="border-bottom">
                  <th scope="col"></th>
                  <th scope="col"></th>
                  <th scope="col"></th>
                  <th scope="col"></th>
                  <th scope="col" className="border-end"></th>
                  <th scope="col" className="border-end" colSpan={3}>Mañana</th>
                  <th scope="col" className="border-end" colSpan={3}>Tarde</th>
                  <th scope="col"></th>
                </tr>
                <tr className="table-active border-bottom">
                  <th scope="col">N° Report</th>
                  <th scope="col">N° Equipo</th>
                  <th scope="col">Fecha</th>
                  <th scope="col">Día</th>
                  <th scope="col">Mes</th>
                  <th scope="col">Hora Inicio</th>
                  <th scope="col">Hora Término</th>
                  <th scope="col">Horas Mañana</th>
                  <th scope="col">Hora Inicio</th>
                  <th scope="col">Hora Término</th>
                  <th scope="col">Horas Tarde</th>
                  <th scope="col">Total Horas</th>
                </tr>
              </thead>
              <tbody>
                {estadoPagoReportsGT ? (
                  estadoPagoReportsGT.map((reportGT, index) => (
                    <tr key={index}>
                      <td>{reportGT.id_report_gt}</td>
                      <td>{reportGT.numero}</td>
                      <td>{reportGT.fecha_report}</td>
                      <td>{capitalizeFirstLetter(reportGT.dia)}</td>
                      <td>{capitalizeFirstLetter(reportGT.mes)}</td>
                      <td>{reportGT.hora_inicio_manana.substring(0, 5)}</td>
                      <td>{reportGT.hora_termino_manana.substring(0, 5)}</td>
                      <td>{reportGT.total_horas_manana.substring(0, 5)}</td>
                      <td>{reportGT.hora_inicio_tarde.substring(0, 5)}</td>
                      <td>{reportGT.hora_termino_tarde.substring(0, 5)}</td>
                      <td>{reportGT.total_horas_tarde.substring(0, 5)}</td>
                      <td>{reportGT.total_horas.substring(0, 5)}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td className="text-center ps-1" colSpan={12}>No se encontraron reports asociados</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="row row-cols-lg-2">
            <div className="col">
              <div className="d-flex justify-content-lg-between mb-3">
                <h5 className="mb-0">Detalle Operador</h5>
                <span className="d-inline-flex align-items-center">
                  <label className="form-label mb-0 me-2">Horas Trabajadas:</label>
                  <span className="fw-bold text-orange">{data.horas_trabajadas_cantidad}</span>
                </span>
              </div>
              <div className="table-responsive border rounded mb-4">
                <table className="table table-hover table-sm mb-0">
                  <thead>
                    <tr className="table-active border-bottom">
                      <th className="col-6 ps-2">Descripción</th>
                      <th className="col-2 pe-2">Detalle</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="ps-2">Horas Incluidas Operador</td>
                      <td className="pe-2 text-end">{data.horas_incluidas_operador}</td>
                    </tr>
                    <tr>
                      <td className="ps-2">Horas Adicionales</td>
                      <td className="pe-2 text-end">{data.horas_adicionales_operador}</td>
                    </tr>
                    <tr>
                      <td className="ps-2">Valor Horas Adicional (UF)</td>
                      <td className="pe-2 text-end">{data.valor_hora_adicional_uf_operador}</td>
                    </tr>
                    <tr>
                      <td className="ps-2">Horas Adicionales Domingos y Festivos</td>
                      <td className="pe-2 text-end">{data.horas_adicionales_domingos_festivos_operador}</td>
                    </tr>
                    <tr>
                      <td className="ps-2">Valor Horas Adicional (UF)</td>
                      <td className="pe-2 text-end">{data.valor_hora_adicional_domingos_festivos_uf_operador}</td>
                    </tr>
                    <tr>
                      <td className="ps-2">Valor UF a Fecha de Facturación</td>
                      <td className="pe-2 text-end"><small className="text-secondary">$</small> {Number(data.valor_uf_fecha_facturacion).toLocaleString('es-ES', { useGrouping: true })}</td>
                    </tr>
                    <tr>
                      <td className="ps-2">Valor Total Horas Adicionales</td>
                      <td className="pe-2 text-end"><small className="text-secondary">$</small> <span className="text-orange">{Number(data.valor_total_horas_adicionales_operador).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.')}</span></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="col">
              <h5 className="mb-3">Detalle Grúa</h5>
              <div className="table-responsive border rounded">
                <table className="table table-hover table-sm mb-0">
                  <thead>
                    <tr className="table-active border-bottom">
                      <th className="col-6 ps-2">Descripción</th>
                      <th className="col-2 pe-2">Detalle</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="ps-2">Horas Incluidas Grúa</td>
                      <td className="text-end">{data.horas_incluidas_grua}</td>
                    </tr>
                    <tr>
                      <td className="ps-2">Horas Trabajadas Grúa</td>
                      <td className="text-end"><span className="fw-bold text-orange">{data.horas_trabajadas_cantidad}</span></td>
                    </tr>
                    <tr>
                      <td className="ps-2">Horas Adicionales</td>
                      <td className="text-end">{data.horas_adicionales_grua}</td>
                    </tr>
                    <tr>
                      <td className="ps-2">Valor Horas Adicional (UF)</td>
                      <td className="text-end">{Number(cardData.valor_hora_adicional_uf_grua).toFixed(4)}</td>
                    </tr>
                    <tr>
                      <td className="ps-2">Valor UF a Fecha de Facturación</td>
                      <td className="text-end"><small className="text-secondary">$</small> {Number(data.valor_uf_fecha_facturacion).toLocaleString('es-ES', { useGrouping: true })}</td>
                    </tr>
                    <tr>
                      <td className="ps-2">Valor Total Horas Adicionales</td>
                      <td className="text-end"><small className="text-secondary">$</small> <span className="text-orange">{Number(cardData.valor_total_horas_adicionales_grua).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.')}</span></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header">
              <ul className="nav nav-tabs card-header-tabs mx-auto">
                <li className="nav-item">
                  <a className={`nav-link ${activeTab === 'resumen' ? 'nav-link active' : 'nav-link'}`} onClick={() => handleTabClick('resumen')}>Resumen</a>
                </li>
                <li className="nav-item">
                  <a className={`nav-link ${activeTab === 'valores' ? 'nav-link active' : 'nav-link'}`} onClick={() => handleTabClick('valores')}>Valores</a>
                </li>
                <li className="nav-item">
                  <a className={`nav-link ${activeTab === 'documentos' ? 'nav-link active' : 'nav-link'}`} onClick={() => handleTabClick('documentos')}>Documentos</a>
                </li>
              </ul>
            </div>
            <div className="card-body p-0">
              <div className="tab-content">
                <div className={`tab-pane p-3 ${activeTab === 'resumen' ? 'active' : ''}`}>
                  <div className="d-flex justify-content-md-between align-items-md-center mb-3">
                    <h5 className="mb-0">Resumen Facturación</h5>
                    <div className="d-inline-flex align-items-center gap-2">
                      <label className="form-label mb-0">Fecha Facturación</label>
                      <input
                        className="form-control form-date-width"
                        type="date"
                        name="fecha_facturacion"
                        max={today.toISOString().split('T')[0]}
                        value={jsonPIGT && jsonPIGT.length > 0 && jsonPIGT[0]?.Fecha ? jsonPIGT[0].Fecha.split('T')[0] : ''}
                        onChange={handleDateFacturacionChange}
                      />
                    </div>
                  </div>
                  {detalleEquipos.map((item, index) => (
                    <div key={index} className="border rounded mb-3">
                      <div className="row g-0">
                        <div className="col-md-8">
                          <ul className="list-group list-group-flush rounded-start border-end">
                            <li className="list-group-item fw-semibold">
                              Arriendo Mensual de Grúa Torre N° {item.numero_equipo}, Obra: {data.nombre_obra}<br />
                              {item.total_horas_trabajadas} Horas Trabajadas<br />
                              Según report {new Date(item.fecha_report).toLocaleString('es-CL', { month: 'long' })} {new Date(item.fecha_report).getFullYear()}
                            </li>
                          </ul>
                        </div>
                        <div className="col-md-4">
                          <ul className="list-group list-group-flush rounded-end">
                            <li className="list-group-item d-flex flex-column justify-content-center align-items-center pt-3">
                              <span className="form-label fw-semibold text-dark mb-0">Total</span>
                              <span className="label">
                                <small className="text-secondary">$ </small>
                                <span className="fs-5">{Number(dataTotales.total).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.') || ""}</span>
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className={`tab-pane p-3 ${activeTab === 'valores' ? 'active' : ''}`}>
                  <div className="row">
                    <div className="col-lg-8">
                      <h5 className="mb-3">Detalle Servicios</h5>
                      <ul className="list-group">
                        {estadoPagoServiciosGT && estadoPagoServiciosGT.length > 0 && estadoPagoServiciosGT.map((servicioGT, index) => (
                          <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                            <span>
                              {<input
                                className="form-check-input me-2"
                                type="checkbox"
                                id={"check_" + index}
                                checked={checkboxStatesServ[index] || false}
                                onChange={(e) => toggleCheckbox(
                                  index,
                                  servicioGT.id_servicio,
                                  servicioGT.glosa_servicio !== null && servicioGT.glosa_servicio !== '' ? (
                                    servicioGT.glosa_servicio
                                  ) : (
                                    servicioGT.id_equipo === 0 ? (
                                      servicioGT.nombre_maquinaria + " - " + servicioGT.tipo_arriendo
                                    ) : (
                                      servicioGT.nombre_maquinaria + " - " + servicioGT.nombre_equipo + " - " + servicioGT.tipo_arriendo
                                    )
                                  ),
                                  Math.round(Number(servicioGT.valor_total)).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, ''))
                                }
                              />}
                              <label className="form-label mb-0" htmlFor={"check_" + index}>
                                {
                                  servicioGT.glosa_servicio !== null && servicioGT.glosa_servicio !== '' ? (
                                    servicioGT.glosa_servicio
                                  ) : (
                                    servicioGT.id_equipo === 0 ? (
                                      servicioGT.nombre_maquinaria + " - " + servicioGT.tipo_arriendo
                                    ) : (
                                      servicioGT.nombre_maquinaria + " - " + servicioGT.nombre_equipo + " - " + servicioGT.tipo_arriendo
                                    )
                                  )
                                }&nbsp;

                                (Valor UF: <span className="fw-bold text-dark">{servicioGT.tipo_facturacion === 'completa' ? Number(servicioGT.valor_unitario_neto).toFixed(2) : Number(servicioGT.valor_parcial_neto).toFixed(2)}</span>)
                              </label>
                            </span>
                            <span className="label text-nowrap"><small className="text-secondary">$ </small>{Math.round(Number(servicioGT.valor_total)).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.')}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="col-lg-4">
                      <h5 className="mb-3">Totales</h5>
                      <ul className="list-group">
                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          <span className="form-label mb-0">Total Neto</span>
                          <span className="label">
                            <small className="text-secondary">$ </small>{Number(dataTotales.total_neto).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.') || ""}
                          </span>
                        </li>
                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          <span className="form-label mb-0">IVA</span>
                          <span className="label">
                            <small className="text-secondary">$ </small>{Number(dataTotales.iva).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.') || ""}
                          </span>
                        </li>
                        {Number(data.otros_descuentos) > 0 ? (
                          <li className="list-group-item">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <span className="form-label mb-0">Descuentos</span>
                              <span className="label">
                                <small className="text-red">- $ </small><span className="text-red">{Number(dataTotales.otros_descuentos).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.') || ""}</span>
                              </span>
                            </div>
                            <div className="border rounded table-active bg-body-secondary py-1 px-2">
                              <small>{data.detalle_otros_descuentos || ""}</small>
                            </div>
                          </li>
                        ) : (
                          <li className="list-group-item">
                            <div className="d-flex justify-content-between align-items-center">
                              <span className="form-label mb-0">Descuentos</span>
                              <span className="label">
                                <small className="text-secondary">$ </small>0
                              </span>
                            </div>
                          </li>
                        )}
                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          <span className="form-label mb-0"><span className="fw-bold text-dark">Total Facturado</span></span>
                          <span className="label">
                            <small className="text-secondary">$ </small><span className="fs-5 text-dark">{Number(dataTotales.total).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.') || ""}</span>
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className={`tab-pane ${activeTab === 'documentos' ? 'active' : ''}`}>
                  <div className="d-flex justify-content-lg-between align-items-center p-3">
                    <h5 className="mb-0">Documentos Asociados</h5>
                    <div className="d-inline-flex gap-2">
                      <button type="button" className="btn btn-outline-dark btn-sm" onClick={handleAgregarFila}>
                        <i className="bi bi-plus-circle"></i> Agregar
                      </button>
                      <button type="button" className="btn btn-dark btn-sm" onClick={(e) => handleConfirmaDocumentos(e, filas)}>
                        <i className="bi bi-floppy"></i> Guardar
                      </button>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-sm table-hover mb-0">
                      <thead>
                        <tr className="table-active border-top border-bottom">
                          <th className="ps-3">Tipo Documento</th>
                          <th>Número</th>
                          <th className="pe-3">Fecha</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {estadoPagoDocumentosGT.length > 0 ? (
                          estadoPagoDocumentosGT.map((documento, index) => (
                            <tr key={index}>
                              <td className="ps-3">{documento.tipo_documento}</td>
                              <td>{documento.detalle}</td>
                              <td>{documento.fecha_detalle}</td>
                              <td className="pe-3"></td>
                            </tr>
                          ))
                        ) : (
                          <tr></tr>
                        )}
                        {filas.map((fila) => (
                          <tr key={fila.id}>
                            <td className="ps-3">
                              <select className="form-select form-select-sm" value={fila.id_tipo_documento} onChange={(e) => handleInputChange(fila.id, 'id_tipo_documento', e.target.value)}>
                                <option value="">Seleccione Tipo de Documento</option>
                                {tiposDocumentos.map((tipo_documento, index) => (
                                  <option key={index} value={tipo_documento.id_tipo_documento}>{tipo_documento.tipo_documento}</option>
                                ))}
                              </select>
                            </td>
                            <td>
                              <input
                                className="form-control form-control-sm"
                                type="text"
                                value={fila.detalle}
                                onChange={(e) =>
                                  handleInputChange(fila.id, 'detalle', e.target.value)
                                }
                              />
                            </td>
                            <td>
                              <input
                                className="form-control form-control-sm"
                                type="date"
                                value={fila.fecha}
                                onChange={(e) =>
                                  handleInputChange(fila.id, 'fecha', e.target.value)
                                }
                              />
                            </td>
                            <td className="pe-3">
                              <button className="btn btn-outline-danger btn-sm" onClick={() => handleEliminarFila(fila.id)}>
                                <i className="bi bi-trash3"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {dataLogin.id_perfil === 1 && (
          <div className="modal-footer justify-content-lg-between">
            <button className="btn btn-outline-primary" onClick={(e) => handleVerPDFep(data, estadoPagoReportsGT, detalleEquipos, estadoPagoServiciosGT)}>
              <i className="bi bi-eye"></i> Ver Documento
            </button>
            <div className="d-inline-flex flex-lg-row gap-2">
              <button className="btn btn-outline-danger" onClick={(event) => handleModificaEstado(data, '2')}><i className="bi bi-dash-circle"></i> Anular</button>
              <button className="btn btn-outline-dark" onClick={(event) => handleEnviaEP(data, estadoPagoReportsGT, detalleEquipos, estadoPagoServiciosGT)}><i className="bi bi-send"></i> Enviar</button>
              <button className="btn btn-yellow" onClick={(event) => handleModificaEstado(data, '3')} disabled={submitFacturarDisabled}><i className="bi bi-check-circle"></i> Facturar</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}